var map = {
	"./01_female_doc.png": 1271,
	"./01_female_doc_avatar.png": 6019,
	"./02_male_doc.png": 3665,
	"./02_male_doc_avatar.png": 3501,
	"./03_female_friend.png": 4631,
	"./03_female_friend_avatar.png": 1363,
	"./04_male_friend.png": 4413,
	"./04_male_friend_avatar.png": 4937,
	"./05_pregnant_girl.png": 5822,
	"./05_pregnant_girl_avatar.png": 3888,
	"./06_female_doc.png": 4610,
	"./06_female_doc_avatar.png": 4132,
	"./07_female_friend.png": 8627,
	"./07_female_friend_avatar.png": 8623,
	"./08_male_doc.png": 8775,
	"./08_male_doc_avatar.png": 6611,
	"./__mock__/mock_image.png": 2205
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1664;